module.exports = __webpack_public_path__ + "static/Chowbus-4b7e6a987b398de4b3fe8ed8c787a03d.jpg";